import React, { FC } from 'react'
import { Box, Heading, Text } from 'grommet'
import { Link } from 'gatsby'
import { useLayoutConfig, ImageSrcI } from '../../custom-hooks/useLayoutConfig'
import ImageCard from '../image-card/ImageCard'

interface PreviewListPropsI {
  list: ImageSrcI[]
}

const PreviewList: FC<PreviewListPropsI> = ({ list }: PreviewListPropsI) => (
  <Box direction="row" wrap={true}>
    {list.map((image, index) => (
      <ImageCard key={image.thumb} allImages={list} currentIndex={index} />
    ))}
  </Box>
)

const GalleryPreview: FC = () => {
  const layoutConfig = useLayoutConfig()

  return (
    <Box margin={{ vertical: 'large', horizontal: 'medium' }}>
      <Box align="center">
        <Heading level={2} size="medium">
          Explore our premises
        </Heading>
      </Box>
      <Box align="end">
        <Link to={'/photo-gallery'}>
          <Text>View All Pics</Text>
        </Link>
      </Box>
      <Box margin={{ top: 'large' }}>
        <PreviewList list={layoutConfig.galleryPreview} />
      </Box>
    </Box>
  )
}

export default GalleryPreview
